<template>
<div class="body">
  <v-card class="ma-0 ma-sm-4 d-flex flex-grow-1 flex-column">
    <div class="flex-grow-1 flex-sm-grow-0 forms-content overflow-auto">
      <h3 class="subtitle-1 mb-1 px-4 pt-4">Filtros</h3>
      <v-divider/>
      <section class="pa-4">
        <v-form ref="form">
          <RelatorioFornecedorForm v-model="filters"/>
        </v-form>
      </section>
      <section v-show="filters.tipo !== 'G'">
        <h3 class="subtitle-1 mb-1 px-4">Ordenação</h3>
        <v-divider/>
        <order-input v-model="orders"/>
      </section>
    </div>
    <v-divider/>
    <section class="pa-2">
      <v-btn block color="primary" @click="openExportMenu">
        Exportar
      </v-btn>
    </section>
        <responsive-menu ref="menu"
          @click:item="exportReport"
          title="Exportar" :opcoes="menuOptions"/>
  </v-card>
  <v-overlay :value="loading" absolute>
    <v-progress-circular
      indeterminate
      color="primary"
      class="ma-4"
    ></v-progress-circular>
  </v-overlay>
</div>
</template>

<script>
import {downloadReport, findAvailableOrders, ReportType} from "@/api/relatorios";
import RelatorioFornecedorForm from "@/components/shared/forms/relatorios/RelatorioFornecedorForm";
import ResponsiveMenu from "@/components/app/ResponsiveMenu";
import OrderInput from "@/components/shared/common/OrderInput";
import {ApiError} from "@/api/core";

export default {
  name: "RelatorioFornecedor",
  components: {OrderInput, ResponsiveMenu, RelatorioFornecedorForm},
  data () {
    return {
      tabSection: 0,
      loading: false,
      menuOptions: [
        {
          action: 'pdf',
          text: 'Exportar como PDF',
          permiteAcao: true,
        },
        {
          action: 'csv',
          text: 'Exportar como CSV',
          permiteAcao: true,
        }
      ],
      filters: {
        tipo: 'S',
        esconderDados: 'S'
      },
      orders: [],
      report: ReportType.REL_FORNECEDOR_OPE
    }
  },
  methods: {
    openExportMenu(ev) {
      if(!this.$refs.form.validate()) return;
      this.$refs.menu.open(ev);
    },
    async exportReport(v) {
      this.loading = true;
      try {
        await downloadReport(this.report, {
          ...this.filters,
          formatoSaida: v,
          ordenacao: this.orders.map(order => order.field)
        });
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(this.formattedMessageAlert(err.message), {
            timeout: 6000
          })
        } else {           
          this.$toast.error(`Não foi possível emitir o relatório.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      } 
    },
    async refreshOrderOPtions() {
      this.orders = await findAvailableOrders(this.report);
    },
  },
  mounted() {
    this.refreshOrderOPtions();
  }
}
</script>

<style scoped lang="scss">
.body {
  width: 100%;
  background-color: white !important; /* Define o fundo branco para todo o componente */
}
.forms-content {
  max-height: calc(100vh - 115px);
}
</style>